import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Settings from './Settings';
import Books from './Books';
import Text from '../../components/Text';
import { FormattedMessage } from 'react-intl';

import CollaborationPage from '../../containers/CollaborationPage';
import CardSection from '../../containers/CardSection';
import ChangePassword from './Settings/ChangePassword';
import Button from '../../components/Button';
import Box from '../../components/layout/Box';

import useLogout from '../../helpers/useLogout';

const Profile = () => {
  const { logout, isLoading: logoutLoading } = useLogout();

  return (
    <CollaborationPage className="pt-3">
      <Box className="mb-3 flex-column">
        <Text variant="sectionTitle">
          <FormattedMessage defaultMessage="Mina sidor" />
        </Text>
        <Text variant="sectionSubtitle" className="mt-1">
          <FormattedMessage defaultMessage="Här kan du uppdatera dina uppgifter och hantera dina annonser" />
        </Text>
      </Box>
      <Tabs
        defaultActiveKey="profile-settings"
        id="profile-tabs"
        className="mb-5"
      >
        <Tab eventKey="profile-settings" title="Uppgifter">
          <CardSection title={<FormattedMessage defaultMessage="Uppgifter" />}>
            <Settings />
          </CardSection>

          <CardSection
            title={<FormattedMessage defaultMessage="Ändra lösenord" />}
          >
            <ChangePassword />
          </CardSection>

          <CardSection
            title={<FormattedMessage defaultMessage="Hantera konto" />}
          >
            <Box>
              <Button isLoading={logoutLoading} onClick={logout}>
                <FormattedMessage defaultMessage="Logga ut" />
              </Button>
            </Box>
          </CardSection>
        </Tab>

        <Tab eventKey="my-books" title="Mina annonser">
          <Books />
        </Tab>
      </Tabs>
    </CollaborationPage>
  );
};

export default Profile;
